import { actions } from './doctors_report/actions'
import { getters } from './doctors_report/getters'
import { state } from './doctors_report/state'
import { mutations } from './doctors_report/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}